import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import Group from "../../../ServicosAcolhimento/Visualizar/Group";
import { useEffect, useState } from "react";
import CriancaService from "../../../../../main/services/CriancaService";

import { TableEducacao } from "../../../../components/TableEducacao";
import { IconeDownload } from "../../../../components/IconeDownload";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import { createCustomFile } from "../../../../utils/createCustomFile";
import { useHistory, useLocation } from "react-router";
import { useFormikContext } from "formik";

export const VisualizarPageSaude = ({
  id,
  setIsTrueVisualizar,
  setInitialValues,
  url,
}) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const { setFieldValue } = useFormikContext();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idAnexo = searchParams.get("idAnexo");

  useEffect(() => {
    setLoading(true);
    CriancaService.getCriancaSaude(id)
      .then((res) => {
        if (res.data) {
          const formatedDeficiencia = res.data.deficiencias.map((item) => {
            return {
              idTipoDeficiencia: item.idTipoDeficiencia,
              descricaoTipoDeficiencia: item.descricaoTipoDeficiencia,
            };
          });

          const deficiencias = [formatedDeficiencia];

          const tratamentos = res.data.tratamentos.map((tratamento) => {
            if (tratamento.laudoMedico) {
              const fakeFile = createCustomFile(
                [tratamento.laudoMedico.arquivoBase64],
                tratamento.laudoMedico.arquivoNome,
                {
                  type: tratamento.laudoMedico.arquivoTipo,
                  idAnexo: tratamento.laudoMedico.idAnexo
                    ? tratamento.laudoMedico.idAnexo
                    : 0,
                }
              );

              return {
                ...tratamento,
                doenca: {
                  idDoenca: tratamento.doenca.id,
                  descricaoDoenca: tratamento.doenca.descricao,
                },
                fazTratamento: tratamento.fazTratamento || "N",
                laudoMedico: fakeFile,
              };
            } else {
              return {
                ...tratamento,
                doenca: {
                  idDoenca: tratamento.doenca.id,
                  descricaoDoenca: tratamento.doenca.descricao,
                },
                fazTratamento: tratamento.fazTratamento || "N",
              };
            }
          });

          setInitialValues({
            deficiencias: deficiencias,
            tratamentos: tratamentos,
            medicacaoContinua: res.data.medicacaoContinua
              ? res.data.medicacaoContinua
              : "",
            possuiDeficiencia: res.data.possuiDeficiencia,
            possuiProblemasSaude: res.data.possuiProblemasSaude,
          });

          setFieldValue("tratamentos", tratamentos);

          setData(res.data);

          if (url.includes("editar")) {
            setIsTrueVisualizar(false);
          } else {
            setIsTrueVisualizar(true);
          }
        } else {
          setIsTrueVisualizar(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        let path = `/crianca/visualizar-saude/${id}`;
        path += idAnexo ? `?idAnexo=${idAnexo}` : "";
        history.push(path);
        setIsTrueVisualizar(false);
        setLoading(false);
      });
  }, [id, url, setInitialValues, history, setIsTrueVisualizar, setFieldValue, idAnexo]);

  const getLaudoMedico = (idCrianca, idSaudeDoenca) => {
    CriancaService.getLaudoMedicoSaudeDownload(idCrianca, idSaudeDoenca)
      .then((res) => {
        const downloadUrl = res.config.url;
        window.open(downloadUrl, "_blank");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columns = [
    {
      Header: "Problema de Saúde",
      accessor: "doenca",
      Cell: (props) => {
        const doenca = props?.value;

        return <span>{doenca.descricao ? doenca.descricao : ""}</span>;
      },
    },
    {
      Header: "Faz Algum Tratamento de Saúde?",
      accessor: "fazTratamento",
      Cell: (props) => {
        const tratamento =
          props?.value === "S"
            ? "Sim"
            : props?.value === "T"
            ? "Sim (Temporário)"
            : props?.value === "P"
            ? "Sim (Permanente)"
            : "Não";

        return (
          <Flex justifyContent={"center"}>
            {tratamento ? tratamento : "Sim"}
          </Flex>
        );
      },
    },
    {
      Header: "Laudo Médico",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        const idSaudeDoenca = props?.value?.idSaudeDoenca;
        const laudo = props?.value?.laudoMedico;

        return (
          <Flex justifyContent={"center"}>
            {laudo ? (
              <button
                type="button"
                onClick={() => getLaudoMedico(id, idSaudeDoenca)}
              >
                <IconeDownload />
              </button>
            ) : (
              ""
            )}
          </Flex>
        );
      },
    },
  ];

  return !loading ? (
    <Group title="Saúde">
      <Flex mt="17px" direction={"column"} gap="18px">
        <Box>
          <Text as="b">Possui Deficiência?</Text>
          <Text>
            {data.possuiDeficiencia === "S"
              ? "Sim. " +
                (data.deficiencias.length === 0
                  ? ""
                  : data.deficiencias.length === 1
                  ? data.deficiencias[0].descricaoTipoDeficiencia
                  : data.deficiencias.length === 2
                  ? `${data.deficiencias[0].descricaoTipoDeficiencia} e ${data.deficiencias[1].descricaoTipoDeficiencia}`
                  : `${data.deficiencias
                      .map((item) => item.descricaoTipoDeficiencia)
                      .slice(0, -1)
                      .join(", ")} e ${
                      data.deficiencias[data.deficiencias.length - 1]
                        .descricaoTipoDeficiencia
                    }`)
              : "Não"}
          </Text>
        </Box>
        <Box>
          <Text as="b">Possui Algum Problema de Saúde?</Text>
          <Text>{data.possuiProblemasSaude === "S" ? "Sim. " : "Não"}</Text>
        </Box>

        {data.possuiProblemasSaude === "S" ? (
          <>
            {data.tratamentos && data.tratamentos.length > 0 && (
              <TableEducacao
                saude={true}
                columns={columns}
                data={data.tratamentos}
              />
            )}
            <Box>
              <Text as="b">Usa Medicação Contínua?</Text>
              <Text>{data.medicacaoContinua === "S" ? "Sim" : "Não"}</Text>
            </Box>
          </>
        ) : (
          ""
        )}
      </Flex>
    </Group>
  ) : (
    <Box mt={4}>
      <LoadingSpinner />
    </Box>
  );
};
